import { render } from "./ResetOutlet.vue?vue&type=template&id=217db942"
import script from "./ResetOutlet.vue?vue&type=script&lang=js"
export * from "./ResetOutlet.vue?vue&type=script&lang=js"

import exportComponent from "/media/alvian/New Volume14/project/vue js/sfa-nepal-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__